export default "{\n    \"heading\": \"Algo salió mal\",\n    \"description\": \"No pudimos cargar esta página. Por favor, intente nuevamente.\"\n}"